import { cn } from "@/lib/utils";
import { type LucideIcon } from "lucide-react";
import { type ReactNode } from "react";

type SectionHeaderWithIconProps = {
  icon?: LucideIcon;
  title: string;
  className?: string;
  /** Colour of the icon and title — muted by default. */
  labelClassName?: string;
  rightSlot?: ReactNode;
};

/**
 * Compact uppercase section header used by the company side panel.
 * Optionally prefixes with a small icon and accepts a trailing
 * action slot (e.g. a "see more" button) on the right.
 */
export default function SectionHeaderWithIcon({
  icon: Icon,
  title,
  className,
  labelClassName,
  rightSlot,
}: SectionHeaderWithIconProps) {
  return (
    <div className={cn("flex items-center justify-between mb-2", className)}>
      <div
        className={cn(
          "flex items-center gap-2 min-w-0 text-muted-foreground",
          labelClassName,
        )}
      >
        {Icon && <Icon className="w-3.5 h-3.5 shrink-0" />}
        <h3 className="text-xs font-semibold uppercase tracking-wider truncate">
          {title}
        </h3>
      </div>
      {rightSlot}
    </div>
  );
}
